
    <button title="Toggle theme" type="button" class="btn btn-success position-fixed bottom-0 end-0 mb-3 me-3"
        (click)="toggleTheme()">
        <fa-icon [icon]="faEclipse"></fa-icon>
    </button>
